import { useQuery } from "@tanstack/react-query";
import { fetchSettings } from "@/lib/api";
import { useEffect } from "react";

export function AdSlot({ slotType = "content" }: { slotType?: "header" | "content" }) {
  const { data: settings } = useQuery({
    queryKey: ["settings"],
    queryFn: fetchSettings,
  });

  const slotId =
    slotType === "header" ? settings?.adsense_slot_header : settings?.adsense_slot_content;

  useEffect(() => {
    try {
      if (settings?.adsense_pub_id && slotId) {
        // @ts-ignore
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (e) {
      console.error("AdSense Error:", e);
    }
  }, [settings?.adsense_pub_id, slotId]);

  if (settings?.adsense_pub_id && slotId) {
    return (
      <div className="my-12 flex flex-col items-center animate-in fade-in duration-700">
        <span className="text-[9px] uppercase tracking-[0.3em] text-muted-foreground mb-4">
          Informasi Komersial
        </span>
        <ins
          className="adsbygoogle"
          style={{ display: "block", width: "100%", minHeight: "100px" }}
          data-ad-client={settings.adsense_pub_id}
          data-ad-slot={slotId}
          data-ad-format="auto"
          data-full-width-responsive="true"
        ></ins>
      </div>
    );
  }

  // Return nothing if no ads are configured to keep it aesthetic
  return null;
}

export function CustomAdSlot() {
  const { data: settings } = useQuery({
    queryKey: ["settings"],
    queryFn: fetchSettings,
  });

  useEffect(() => {
    if (settings?.custom_ad_code) {
      // Find scripts and execute them manually as dangerouslySetInnerHTML doesn't execute scripts
      const div = document.getElementById("custom-ad-container");
      if (div) {
        const scripts = div.getElementsByTagName("script");
        for (let i = 0; i < scripts.length; i++) {
          const script = document.createElement("script");
          if (scripts[i].src) {
            script.src = scripts[i].src;
          } else {
            script.textContent = scripts[i].textContent;
          }
          script.async = true;
          document.body.appendChild(script);
        }
      }
    }
  }, [settings?.custom_ad_code]);

  if (!settings?.custom_ad_code) return null;

  return (
    <div className="my-12 flex flex-col items-center animate-in fade-in duration-700">
      <span className="text-[9px] uppercase tracking-[0.3em] text-muted-foreground mb-4">
        Promosi
      </span>
      <div 
        id="custom-ad-container"
        className="w-full flex justify-center overflow-hidden"
        dangerouslySetInnerHTML={{ __html: settings.custom_ad_code }} 
      />
    </div>
  );
}
